<template>
  <v-layout v-if="qId && errors" row wrap>
    <v-flex xs12 md11 offset-md1 lg9 offset-lg2>
      <ul style="list-style:none;padding-left: 0;">
        <li v-for="(error, index) in errors" :key="index">
          <v-alert
            :class="error.severityType === $getConst('VALIDATION_SEVERITY_TYPE', 'ERROR') ? 'errorFieldMessage' : 'warningFieldMessage'"
            class="fieldKMsg-shared px-3 py-0 mb-2" v-model="!errors[index].isDismissed">
            <v-container>
              <v-row>
                <!-- :xs11="isDismissible(error.severityType)"
                :xs12="!isDismissible(error.severityType)"-->
                <v-col class="flex-grow-1 pa-2 pl-3">
                  <wes-question-number
                    :type="getNumberType(error.severityType)"
                    v-bind:index="(error.index).toString()"
                  ></wes-question-number>&nbsp;
                  <strong>{{error.title}}:</strong>&nbsp;
                  <span v-html="error.message"></span>
                </v-col>
                <v-col
                  class="flex-grow-0 align-self-center pa-0"
                  v-if="isDismissible(error.severityType)"
                >
                  <v-btn class="ma-1" text icon @click="onDismissed(index)">
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-alert>
        </li>
      </ul>
      <v-snackbar
        class="snack-warning mb-2"
        v-model="snackbar"
				bottom
        :multi-line="true"
        :timeout="0"
      >
        <v-icon large class="mr-3 white--text">error_outline</v-icon>
        Please provide an explanation in the comments box for question {{qId}} before dismissing the warning(s).
        <v-btn
          class="primary white--text mr-2"
          text
          :elevation="0"
          :outlined="true"
          @click="snackbar = false"
        >Close</v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
/**
 * Creates the in-row validation message. This handles all field type validation messages.
 */
import { CONSTANTS } from "@/common/constants.js";
export default {
  name: "ValueValidationMessage",
  props: {
    /**
     * The question identifier.
     */
    qId: Number,
    /**
     * SubSectionIds is an array holding all row identifiers we want to try and match against error message sub section ids.
     * Ex. For row "42. Systems and Analyses Center" subSectionIds holds [ "42", "Systems and Analyses Center", "000007" ]
     */
    subSectionIds: Array,
    /**
     * The index number of the row within the question.
     */
    rowIndex: { type: Number, default: 0 },
    /**
     * An array of strings, the answer ids for the row the validation message is attached.
     */
    answerIds: Array,
    /**
     * Bool to check if there is text in the explanation box.
     */
    hasExp: Boolean
  },
  components: {},
  data: () => ({
    snackbar: false
    // errors: []
  }),
  created () {},
  methods: {
    onDismissed (index) {
      if (this.hasExp) {
        this.snackbar = false;
        var warningId = {
          id: this.errors[index].surveyMessageId
        };

        this.$store.dispatch("validation/dismissValidation", warningId);
      } else {
        // Error message for the user to know that they need to provide an explanation before dismiss
        this.snackbar = true;
      }
    },
    /**
     * Translates validation type to the appropriate question type.
     */
    getNumberType: function (severityType) {
      if (severityType === CONSTANTS.VALIDATION_SEVERITY_TYPE.ERROR) {
        return CONSTANTS.QUESTION_NUMBER_TYPE.ERROR;
      } else if (severityType === CONSTANTS.VALIDATION_SEVERITY_TYPE.WARNING) {
        return CONSTANTS.QUESTION_NUMBER_TYPE.TREND;
      }
      return null;
    },
    isDismissible (type) {
      return type === CONSTANTS.VALIDATION_SEVERITY_TYPE.WARNING;
    }
  },
  computed: {
    errors () {
      // console.log(
      //   `question: ${this.qId}, subSectionIds: ${this.subSectionIds}, answer: ${this.answerIds}`
      // );
      return this.$store.getters["validation/validationMessagesForQuestionRow"](
        this.qId,
				this.subSectionIds,
        this.answerIds
      );
		}
  }
};
</script>

<style scoped>
div.fieldKMsg-shared {
  /* padding: 6px 20px 4px 15px; */
  border: 1px solid black;
}

div.errorFieldMessage {
  border-color: #c00000;
  background-color: #ffe7e7;
}
div.warningFieldMessage {
  border-color: #bf9000;
  background-color: #ffe699;
}
.snack-warning {
  /* color: #212121 !important; */
}
</style>
